/**
 * shacl-error-toast — surfaces ShaclViolationError via the existing
 * Studio toaster (`@/store/toast-store` + `<Toaster />` mounted in
 * `studio-shell.tsx`).
 *
 * Lives next to ShaclViolationError so callers can `import { showShaclErrorToast }`
 * with a single import path. `formatShaclMessage` is exposed separately so
 * the ChatRail `mutation-failed` message kind can render the same text.
 */

import { useToastStore } from '@/store/toast-store'
import type { ShaclViolation, ShaclViolationError } from './shacl-error'

const TOAST_DURATION_MS = 8000

export function formatShaclMessage(violations: readonly ShaclViolation[]): string {
  if (violations.length === 0) {
    return 'SHACL validation failed (no violations reported)'
  }
  const first = violations[0]
  const focus = lastSegment(first.focusNode)
  const path = first.resultPath ? lastSegment(first.resultPath) : ''
  const head = path ? `${focus} · ${path}` : focus
  if (violations.length === 1) {
    return `${head} — ${first.message}`
  }
  return `${violations.length} SHACL violations · first: ${head} — ${first.message}`
}

export function showShaclErrorToast(err: ShaclViolationError): void {
  const message = formatShaclMessage(err.violations)
  useToastStore.getState().addToast({
    type: 'error',
    message,
    duration: TOAST_DURATION_MS,
  })
}

function lastSegment(iri: string): string {
  const idx = Math.max(iri.lastIndexOf('#'), iri.lastIndexOf('/'))
  return idx >= 0 ? iri.slice(idx + 1) : iri
}
